<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-header>
      <div class="listtitle">物资出入库记录</div>
      <el-form class="zj-search-form clear" ref="form" :model="form" :label-width="labelWidth">
        <el-form-item label="开始日期">
          <el-date-picker placeholder="选择日期" v-model="BeginDate" style="width:30rem"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期">
          <el-date-picker placeholder="选择日期" v-model="EndDate" style="width:30rem"></el-date-picker>
        </el-form-item>
        <el-form-item label="仓库名称">
          <el-input v-model="WarehouseName" style="width:30rem"></el-input>
        </el-form-item>
        <el-form-item label="物资名称">
          <el-input v-model="MaterialId" style="width:30rem"></el-input>
        </el-form-item>
        <el-form-item label class="right">
          <el-button @click="onSearch">查 询</el-button>
          <el-button @click="onCancel">清 理</el-button>
        </el-form-item>
      </el-form>
      <el-divider></el-divider>
    </zj-layout-header>
    <zj-layout-main>
      <el-table
        :data="tableData"
        ref="multipleTable"
        @selection-change="selectionChange"
        border
        style="width: 100%"
        height="100%"
      >
        <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
        <el-table-column prop="MaterialName" label="物资名称"></el-table-column>
        <el-table-column
          prop="MaterialType"
          label="物资类型"
          :formatter="ConvertMaterialType"
          align="center"
        ></el-table-column>
        <el-table-column prop="WarehouseName" label="仓库名称" align="center"></el-table-column>
        <el-table-column prop="InNum" label="入库" align="center"></el-table-column>
        <el-table-column prop="OutNum" label="出库" align="center"></el-table-column>
        <el-table-column
          prop="OperateTime"
          label="出入库时间"
          :formatter="formatDate"
          width="180"
          align="center"
        ></el-table-column>
        <el-table-column prop="OperatePerson" label="领取人" align="center"></el-table-column>
        <el-table-column prop="Creater" label="操作人" align="center"></el-table-column>
        <el-table-column label="操作" width="130" align="center">
          <template slot-scope="scope">
            <el-button @click="deleteClick(scope.$index,scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </zj-layout-main>
    <zj-layout-footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="total"
      ></el-pagination>
    </zj-layout-footer>
  </zj-layout-container>
</template>

<script>
import ZJApp from "../../../../../app";
import MyApis from "../../../apis";
const utils = ZJApp.ZJUtils;
export default {
  name: "ZjMaterialResourcerecordlist",
  controller: "UI",
  action: "MaterialResourcerecordlist",
  data() {
    return {
      loading: false,
      loadingText: "加载中...",
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      BeginDate: null,
      EndDate: null,
      WarehouseName: "",
      MaterialId: "",
      selectData: null,
      options: [],
      MaterialTypeDic: []
    };
  },
  created: function() {
    this.loading = true;
    this.loadingText = "加载中...";
    utils
      .waitAll([this.config.getUValue("EmergencyService:MaterialType:", "")])
      .then(r => {
        this.options = r[0].JValue;
        for (var i = 0; i < this.options.length; i++) {
          var item = this.options[i];
          this.MaterialTypeDic[item.ItemKey] = item.Extend1;
        }
        this.loading = false;
        this.search();
      })
      .catch(e => {
        console.error(e);
        this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        this.loading = false;
      });
  },
  mounted: function() {
    this.logInfo.ActionName = "物资出入库记录查看";
    this.logInfo.LogMessage = "物资出入库记录查看";
    this.logInfo.ModuleName = "应急系统";
    this.logInfo.PageName = "物资出入库记录";
    this.addOperationLog();
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    // 表格的选中 可以获得当前选中的数据
    selectionChange(val) {
      // 将选中的数据存储起来
      this.selectData = val;
    },
    search() {
      let searchInfo = {
        BeginDate: this.BeginDate,
        EndDate:
          this.EndDate == null
            ? null
            : new Date((this.EndDate / 1000 + 86400) * 1000),
        WarehouseName: this.WarehouseName,
        MaterialName: this.MaterialId,
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0
      };
      this.loading = true;
      this.loadingText = "加载中...";
      new MyApis.MaterialResourcerecordApi()
        .GetPageContentByConditions(searchInfo)
        .then(r => {
          //console.log("1");
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.loading = false;
        });
    },
    clearsearch() {
      (this.BeginDate = null),
        (this.EndDate = null),
        (this.WarehouseName = ""),
        (this.MaterialId = "");
      this.search();
    },
    // 点击查询按钮
    onSearch() {
      if (new Date(this.EndDate) < new Date(this.BeginDate)) {
        this.$message.error("开始日期不能大于结束日期");
        return;
      }
      this.currentPage = 1;
      this.search();
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
    },

    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.loading = true;
        this.loadingText = "删除中...";
        new MyApis.MaterialResourcerecordApi()
          .DelItem(row)
          .then(r => {
            r = r.data.Data;
            if (r) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
            } else {
              this.$message({
                type: "error",
                message: "删除失败!"
              });
            }
            this.loading = false;
            this.search();
          })
          .catch(e => {
            console.error(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.loading = false;
          });
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    ConvertMaterialType(row, column) {
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      let levelstr = this.MaterialTypeDic[data];
      return levelstr;
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    }
  }
};
</script>